export class AdminService {

  static async login(passcode: string): Promise<boolean> {
    try {
      const res = await fetch("/api/admin/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ passcode }),
        credentials: 'include'
      });

      return res.ok;
    } catch (error) {
      console.warn("管理者ログインAPIの呼び出しに失敗しました", error);
      return false;
    }
  }

  static async logout(): Promise<void> {
    await fetch('/api/admin/logout', { 
      method: 'POST',
      credentials: 'include'
    });
  }

  static async selectVideo(videoId: string): Promise<boolean> {
    const res = await fetch('/api/admin/video/select', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ videoId }),
      credentials: 'include'
    });
    return res.ok;
  }

  static async play(): Promise<void> {
    await fetch('/api/admin/player/play', { 
      method: 'POST',
      credentials: 'include'
    });
  }

  static async pause(): Promise<void> {
    await fetch('/api/admin/player/pause', { 
      method: 'POST',
      credentials: 'include'
    });
  }

  static async seek(seconds: number): Promise<void> {
    await fetch('/api/admin/player/seek', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ seconds }),
      credentials: 'include'
    });
  }

  static async next(): Promise<void> {
    await fetch('/api/admin/player/next', { 
      method: 'POST',
      credentials: 'include'
    });
  }

  static async toggleAutoRotate(enabled: boolean): Promise<void> {
    await fetch('/api/admin/autorotate', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ enabled }),
      credentials: 'include'
    });
  }
}


